import {Route} from 'vue-router';
import {NextMiddleware} from '@/types';
// import {can} from '@/services/acl.service';

export default function(to: Route, from: Route, next: NextMiddleware) {
  // if (!can(to.meta.permissions || [])) {
  //   next({
  //     path: 'unauthorized',
  //     query: {
  //       from: to.path,
  //     },
  //   });
  // } else {
  //   next();
  // }
  next();
}
